// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1E-Jb","col":"CardReaderDesc_col__C1FEQ","label":"CardReaderDesc_label__3BFsy"};